package com.patronat.top.dto

import kotlinx.datetime.Instant
import kotlinx.datetime.serializers.InstantIso8601Serializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed interface ProfileResponse

// --- Варіант 1: Один профіль ---
@Serializable
@SerialName("single_profile")
data class ProfileSuccessResponse(
    val id: String,
    val phone: String,
    val email: String?,
    val firstName: String,
    val lastName: String,
    val role: UserRole,
    val status: UserStatus,
    val isPhoneVerified: Boolean,
    val isEmailVerified: Boolean,
    @Serializable(with = InstantIso8601Serializer::class)
    val createdAt: Instant,
    val avatarUrl: String? = null,
    val avatarMediaId: String? = null,
) : ProfileResponse


@Serializable
@SerialName("profile_list")
data class ProfileListResponse(
    val items: List<ProfileSuccessResponse>,
    val totalCount: Long,
    val page: Int,
    val pageSize: Int
) : ProfileResponse

@Serializable
data class ContactSupportResponse(
    val id: String
)
